/** The periods `GET /insider-trading/company` accepts. */
export type InsiderPeriod = "3M" | "6M" | "1Y";

interface InsiderPeriodOption {
  label: string;
  /** The Insiders tab's control value, also the chart's date window. */
  months: number;
  period: InsiderPeriod;
}

export const INSIDER_PERIOD_OPTIONS: readonly InsiderPeriodOption[] = [
  { label: "3M", months: 3, period: "3M" },
  { label: "6M", months: 6, period: "6M" },
  { label: "1Y", months: 12, period: "1Y" },
];

export const DEFAULT_INSIDER_PERIOD_MONTHS = 12;

/** The tab's months value → the route's `period`. Anything unknown asks for the full year. */
export const insiderPeriodForMonths = (months: number): InsiderPeriod =>
  INSIDER_PERIOD_OPTIONS.find((option) => option.months === months)?.period ?? "1Y";
